import useAppModal from 'hooks/useAppModal';
import { useTranslation, Trans } from 'react-i18next';

const useSaveConfirmationModal = () => {
  const { t } = useTranslation();
  const { openConfirmModal } = useAppModal();

  const openSaveConfirmationModal = ({
    customTemplateName,
    onAfterConfirm,
  }: {
    customTemplateName: string;
    onAfterConfirm: () => Promise<void>;
  }) => {
    openConfirmModal({
      title: t('pageAutomations.customTemplates.modal.saveConfirmation.title'),
      body: (
        <Trans
          i18nKey="pageAutomations.customTemplates.modal.saveConfirmation.body"
          values={{ name: customTemplateName }}
          components={{ br: <br /> }}
        />
      ),
      cancelColor: 'default',
      onConfirmAsync: onAfterConfirm,

      confirmColor: 'primary',
      confirmLabel: t('common.update'),
    });
  };

  return { openSaveConfirmationModal };
};

export default useSaveConfirmationModal;
